import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const ValidIncidentsPerCategory
 = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="CATEGORY"  disaggregation = "sex"/>
        </>
    
  )
}

export default ValidIncidentsPerCategory
